import React from "react";
import { ArrowDownLightIcon } from "../../../assets";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../redux/store";
import { setTraditionalQuoteData } from "../../../redux/reducer/locationSlice/locationSlice";

interface Column {
  header: string;
  key: string;
  count?: boolean;
  sortable?: boolean;
  className: string;
  dollar?: boolean;
  hide?: boolean
}

interface Data {
  [key: string]: any;
}

interface ViewDetailsTableProps {
  columns: Column[];
  data: Data[];
  handleViewDetails: (rowData: Data) => void;
  handleSelect: (rowData: Data) => void;
  className?: string;
  quoteSelectedId?: string;
  quoteData?: any;
  formData?: any;
  callingFrom?: any;
  isSelected?: any;
  setIsSelected?: any;
  isLtlFm?: boolean;
  masterHubNameToTransfer?: string;
  masterHubAddressToTransfer?: any;
  setOrderTypeRowData?: (data: any) => void;
  fields?: any;
  setFields?: (data: any) => void;
  ltlFMData?: any;
  setLtlFMData?: (data: any) => void;
  ltlAccessorialData?: any;
  lfmQuoteId?: any;
  setIsSelectedParent?: (data: any) => void;
}

const ViewDetailsTable: React.FC<ViewDetailsTableProps> = (props) => {
  const { columns, data, handleViewDetails, handleSelect, className, quoteSelectedId, quoteData, formData, callingFrom, isSelected, setIsSelected, isLtlFm, masterHubNameToTransfer, masterHubAddressToTransfer, setOrderTypeRowData, fields, setFields, ltlFMData, setLtlFMData, ltlAccessorialData, lfmQuoteId, setIsSelectedParent } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orderTypes } = useSelector((state: RootState) => state.staticData);
  const ltlFMOrderType: any = orderTypes.find((order: any) => order.name === "LTL + Final Mile");

  return (
    <>
      <div className="tableContainer">
        <table className={`table ${className}`}>
          <thead>
            <tr>
              {columns.map((column, index) => (
                !column?.hide && <th key={index}>
                  {column.count ? (
                    column.header
                  ) : (
                    <div className="sortingDiv">
                      {column.header}
                      {column.sortable && (
                        <span className="sortingDiv__icon">
                          <ArrowDownLightIcon />
                        </span>
                      )}
                    </div>
                  )}
                </th>
              ))}
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {data?.length === 0 ? (
              <tr>
                <td colSpan={columns?.filter(c => !c?.hide)?.length + 1}>
                  <div className="no-data floating">No Results Found!</div>
                </td>
              </tr>
            ) : (
              data?.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((column, colIndex) => (
                    !column?.hide && <td key={colIndex}>
                      {column?.className === "count" ? (
                        <div className="cellText">
                          <span className="cellText__dark cellText__dark--gray">
                            {row[column.key]}
                          </span>
                        </div>
                      ) : (
                        <div className="cellText">
                          <span className="cellText__dark">
                            {column?.dollar
                              ? `$${row[column.key]?.toFixed(2)}`
                              : row[column.key]}
                          </span>
                        </div>
                      )}
                    </td>
                  ))}
                  <td>
                    <div className="actions flex--center">
                      <button
                        className="link link__primary link--bold"
                        onClick={() => handleViewDetails(row)}
                      >
                        View
                      </button>
                      <button
                        className="btn btn__primary btn__outlined btn--medium"
                        onClick={() => {

                          if (callingFrom === "quickQuote") {

                            let updatedData = {};
                            if (isLtlFm) {
                              updatedData = {
                                ...formData,
                                MidStopAddress: masterHubAddressToTransfer?.address ? masterHubAddressToTransfer?.address : (row?.ltlFMData?.hub?.address?.address || ""),
                                MidStopAPTSuit: masterHubAddressToTransfer?.aptSuit ? masterHubAddressToTransfer?.aptSuit : (row?.ltlFMData?.hub?.address?.aptSuit || ""),
                                MidStopZipcode: masterHubAddressToTransfer?.zipCode ? masterHubAddressToTransfer?.zipCode : (row?.ltlFMData?.hub?.address?.zipCode || ""),
                                MidStopCity: masterHubAddressToTransfer?.city ? masterHubAddressToTransfer?.city : (row?.ltlFMData?.hub?.address?.city || ""),
                                MidStopState: masterHubAddressToTransfer?.state ? masterHubAddressToTransfer?.state : (row?.ltlFMData?.hub?.address?.state || ""),
                                MidStopCountry: masterHubAddressToTransfer?.country ? masterHubAddressToTransfer?.country : (row?.ltlFMData?.hub?.address?.country || ""),
                                MidStopContactName: masterHubAddressToTransfer?.contactPerson ? masterHubAddressToTransfer?.contactPerson : (row?.ltlFMData?.hub?.address?.contactPerson || ""),
                                MidStopPhoneNumber: masterHubAddressToTransfer?.phoneNumber ? masterHubAddressToTransfer?.phoneNumber : (row?.ltlFMData?.hub?.address?.phoneNumber || ""),
                                MidStopPhoneNumberExt: masterHubAddressToTransfer?.countryCallingCode ? masterHubAddressToTransfer?.countryCallingCode : (row?.ltlFMData?.hub?.address?.countryCallingCode || "+1"),
                                MidStopContactEmail: masterHubAddressToTransfer?.contactEmail ? masterHubAddressToTransfer?.contactEmail : (row?.ltlFMData?.hub?.address?.contactEmail || []),
                                agentHubId: row?.ltlFMData?.hub?.id,
                                selectedServiceId: row?.ltlFMData?.service?.id,
                                selectedQuoteId: row?.quoteId,
                                allQuoteId: row?.allQuoteId,
                                CarrierName: row?.carrierName,
                                serviceCost: row?.priceWithMarkUpString,
                                scac: row?.scac,
                                distance: row?.miles || 0,
                                offerId: row?.offerId,
                                // costDetails: additionalCharges(row),
                                markup: row?.markup,
                                productTransactionId: row?.productTransactionId,
                                customerMarkupType: row?.customerMarkupType,
                                plProvider: "",
                                courierPro1: "",
                                courierPro2: "",
                                //Final mile box data
                                agentName: row?.agentName,
                                hubName: row?.hubName,
                                city: masterHubAddressToTransfer?.city ? masterHubAddressToTransfer?.city : row?.address?.city,
                                zipCode: masterHubAddressToTransfer?.zipCode ? masterHubAddressToTransfer?.zipCode : row?.address?.zipCode,
                                country: masterHubAddressToTransfer?.country ? masterHubAddressToTransfer?.country : row?.address?.country,
                                AgentHubId: row?.agentHubId,
                                distanceToDestination: row?.distanceToDestination,
                                operationHrsFrom: masterHubAddressToTransfer?.operationHrsFrom ? masterHubAddressToTransfer?.operationHrsFrom : row?.operationHrsFrom,
                                operationHrsTo: masterHubAddressToTransfer?.operationHrsTo ? masterHubAddressToTransfer?.operationHrsTo : row?.operationHrsTo,
                                quotePrice: row?.quotePrice,
                                pickupAccessorials: row?.pickupAccessorials,
                                dropAccessorials: row?.dropAccessorials,
                                pickupLimitedAccess: row?.pickupLimitedAccess,
                                dropLimitedAccess: row?.dropLimitedAccess,
                                finalmile_quote_id: row?.finalMileData?.service?.quoteId,
                                internalLTL: row?.internalLTL,
                                isProvidence: row?.isProvidence,
                                orderFor: row?.orderFor,
                                carrierQuoteId: row?.carrierQuoteId,
                                rateRequestLocator: row?.rateRequestLocator,
                              }
                            }
                            else {
                              updatedData = {
                                ...formData,
                                MidStopAddress: masterHubAddressToTransfer?.address ? masterHubAddressToTransfer?.address : (row?.address?.address || ""),
                                MidStopAPTSuit: masterHubAddressToTransfer?.aptSuit ? masterHubAddressToTransfer?.aptSuit : (row?.address?.aptSuit || ""),
                                MidStopZipcode: masterHubAddressToTransfer?.zipCode ? masterHubAddressToTransfer?.zipCode : (row?.address?.zipCode || ""),
                                MidStopCity: masterHubAddressToTransfer?.city ? masterHubAddressToTransfer?.city : (row?.address?.city || ""),
                                MidStopState: masterHubAddressToTransfer?.state ? masterHubAddressToTransfer?.state : (row?.address?.state || ""),
                                MidStopCountry: masterHubAddressToTransfer?.country ? masterHubAddressToTransfer?.country : (row?.address?.country || ""),
                                MidStopContactName: masterHubAddressToTransfer?.contactPerson ? masterHubAddressToTransfer?.contactPerson : (row?.address?.contactPerson || ""),
                                MidStopPhoneNumber: masterHubAddressToTransfer?.phoneNumber ? masterHubAddressToTransfer?.phoneNumber : (row?.address?.phoneNumber || ""),
                                MidStopPhoneNumberExt: masterHubAddressToTransfer?.countryCallingCode ? masterHubAddressToTransfer?.countryCallingCode : (row?.address?.countryCallingCode || "+1"),
                                MidStopContactEmail: masterHubAddressToTransfer?.contactEmail ? masterHubAddressToTransfer?.contactEmail : (row?.address?.contactEmail || []),
                                agentHubId: row?.agentHubId,
                                selectedServiceId: row?.id,
                                // The order screen seeds its Service Level chip from
                                // `service`, but formData carries the quote form's
                                // `serviceSelected`, which is just the first entry of a
                                // multi-service selection. Carry the clicked row's
                                // service so the order opens on the quote that was
                                // actually picked.
                                //
                                // Final Mile only — it is the sole order type that can
                                // quote several services at once, so it is the only one
                                // where the two can disagree. Every other type keeps
                                // formData.service untouched.
                                ...(formData?.orderType?.name === "Final Mile" &&
                                  row?.id
                                  ? {
                                    service: {
                                      id: row.id,
                                      name: row?.serviceName ?? "",
                                    },
                                  }
                                  : {}),
                                selectedQuoteId: row?.quoteId,
                                allQuoteId: row?.allQuoteId,
                                CarrierName: row?.carrierName,
                                serviceCost: row?.priceWithMarkUpString,
                                scac: row?.scac,
                                distance: row?.miles,
                                offerId: row?.offerId,
                                // costDetails: additionalCharges(row),
                                markup: row?.markup,
                                productTransactionId: row?.productTransactionId,
                                customerMarkupType: row?.customerMarkupType,
                                plProvider: "",
                                courierPro1: "",
                                courierPro2: "",
                                //Final mile box data
                                agentName: row?.agentName,
                                hubName: row?.hubName,
                                city: masterHubAddressToTransfer?.city ? masterHubAddressToTransfer?.city : row?.address?.city,
                                zipCode: masterHubAddressToTransfer?.zipCode ? masterHubAddressToTransfer?.zipCode : row?.address?.zipCode,
                                country: masterHubAddressToTransfer?.country ? masterHubAddressToTransfer?.country : row?.address?.country,
                                AgentHubId: row?.agentHubId,
                                distanceToDestination: row?.distanceToDestination,
                                operationHrsFrom: masterHubAddressToTransfer?.operationHrsFrom ? masterHubAddressToTransfer?.operationHrsFrom : row?.operationHrsFrom,
                                operationHrsTo: masterHubAddressToTransfer?.operationHrsTo ? masterHubAddressToTransfer?.operationHrsTo : row?.operationHrsTo,
                                quotePrice: row?.quotePrice,
                                pickupAccessorials: row?.pickupAccessorials,
                                dropAccessorials: row?.dropAccessorials,
                                pickupLimitedAccess: row?.pickupLimitedAccess,
                                dropLimitedAccess: row?.dropLimitedAccess,
                                internalLTL: row?.internalLTL,
                                source: row?.source,
                                orderFor: row?.orderFor,
                                isProvidence: row?.isProvidence
                              }
                            }
                            setIsSelected(true);
                            setIsSelectedParent && setIsSelectedParent(true);
                            handleSelect(row);
                            navigate("/customer-order", {
                              state: {
                                page: "Quick Quote",
                                data: updatedData,
                                quoteId: lfmQuoteId,
                                selectedRow: row,
                              },
                            });
                          }
                          else if (callingFrom === "quickQuoteLTL") {
                            setIsSelected(true);
                            setIsSelectedParent && setIsSelectedParent(true);
                            handleSelect(row);
                            if (row?.orderTypeName === "LTL + Final Mile") {

                              setOrderTypeRowData?.({
                                id: ltlFMOrderType?.id,
                                name: ltlFMOrderType?.name,
                                description: ltlFMOrderType?.description,
                              });
                              setFields?.((prev: any) => ({
                                ...prev,
                                CarrierName: row?.carrierName ?? "",
                                scac: row?.scac ?? "",
                                serviceCost: row?.priceWithMarkUpString ?? "",
                                finalmile_quote_id: row?.finalMileData?.service?.quoteId
                              }));
                              setLtlFMData?.({
                                "CarrierName": row?.carrierName ?? "",
                                "scac": row?.scac ?? "",
                                "serviceCost": quoteData[row?.count - 1]?.totalPrice ?? "",
                                "finalMileData": quoteData[row?.count - 1]?.finalMileData,
                                "offerId": quoteData[row?.count - 1]?.offerId,
                                "productTransactionId": quoteData[row?.count - 1]?.productTransactionId
                              })
                              const updatedData = {
                                ...formData,
                                finalmile_quote_id: row?.finalMileData?.service?.quoteId
                              }
                              navigate("/customer-order", {
                                state: {
                                  page: "Quick Quote",
                                  data: updatedData,
                                  quoteType: "traditional",
                                  selectedData: row,
                                  isSelected: row?.banyanType || row.orderFor === "providence" ? false : true,
                                  quoteData: quoteData[row?.count - 1],
                                  ltlAccessorialData: ltlAccessorialData
                                },
                              });
                              return
                            }
                            navigate("/customer-order", {
                              state: {
                                page: "Quick Quote",
                                data: formData,
                                quoteType: "traditional",
                                selectedData: row,
                                isSelected: row?.banyanType || row.orderFor === "providence" ? false : true,
                                quoteData: quoteData[row?.count - 1],
                                ltlAccessorialData: ltlAccessorialData
                              },
                            });
                          }
                          else {
                            if (callingFrom === "Traditional Quote") {
                              setIsSelectedParent && setIsSelectedParent(true);
                              handleSelect(row);
                              if (row?.orderTypeName === "LTL + Final Mile") {

                                setOrderTypeRowData?.({
                                  id: ltlFMOrderType?.id,
                                  name: ltlFMOrderType?.name,
                                  description: ltlFMOrderType?.description,
                                });
                                setFields?.((prev: any) => ({
                                  ...prev,
                                  CarrierName: row?.carrierName ?? "",
                                  scac: row?.scac ?? "",
                                  serviceCost: row?.priceWithMarkUpString ?? "",
                                }));
                                setLtlFMData?.({
                                  "CarrierName": row?.carrierName ?? "",
                                  "scac": row?.scac ?? "",
                                  "serviceCost": quoteData[row?.count - 1]?.totalPrice ?? "",
                                  "finalMileData": quoteData[row?.count - 1]?.finalMileData,
                                  "offerId": quoteData[row?.count - 1]?.offerId,
                                  "productTransactionId": quoteData[row?.count - 1]?.productTransactionId
                                })

                                const updatedData = {
                                  ...formData,
                                  finalmile_quote_id: row?.finalMileData?.service?.quoteId
                                }
                                navigate("/customer-order", {
                                  state: {
                                    page: "Traditional Quote",
                                    data: updatedData,
                                    quoteType: "traditional",
                                    selectedData: row,
                                    isSelected: row?.banyanType || row.orderFor === "providence" ? false : true,
                                    quoteData: quoteData[row?.count - 1],
                                    ltlAccessorialData: ltlAccessorialData
                                  },
                                });
                                return
                              }

                              // Save data in Redux for Traditional Quote case
                              dispatch(setTraditionalQuoteData({
                                page: "Traditional Quote",
                                data: formData,
                                quoteType: "traditional",
                                selectedData: row,
                                isSelected: true,
                                quoteData: quoteData[row?.count - 1],
                                ltlAccessorialData: ltlAccessorialData
                              }));

                              // navigate("/customer-order");
                            }
                            else {
                              setIsSelectedParent && setIsSelectedParent(true);
                              handleSelect(row);
                            }
                          }
                        }}
                      >
                        Select
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div >
    </>
  );
};

export default ViewDetailsTable;
